/*global __CLIENT__*/
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Map } from 'immutable';
import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
import { validateAndDispatch } from '../../helpers/form';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import moment from 'moment';

import { ModalActions } from '../../actions/modal';
import { ReportActions } from '../../actions/report';
import InputBox from '../inputs/InputBox';
import { currentReportSelector } from '../../reducers/reports.js';
import { modalSelector } from '../../reducers/modal.js';
import { currentProjectIdSelector } from '../../reducers/projects.js';
import { projectTimezoneIdSelector } from '../../reducers/projects';
import { timezonesSelector, getTimezoneOffset } from '../../reducers/timezones';
import { formatDate } from '../../helpers/timezone';
// import { timeZoneHelperSelector } from '../types/TimeZone/TimeZoneHelpers';

const createReportFormSelector = state => {
  const selector = formValueSelector('createReport');
  return selector(state, 'type');
};

const timezoneOffsetSelector = state => {
  const timezones = timezonesSelector(state);
  const projectTimezoneId = projectTimezoneIdSelector(state);
  return getTimezoneOffset(timezones, projectTimezoneId);
};

const CreateReportSelector = immutableCreatorSelector(
  [
    createReportFormSelector,
    modalSelector,
    currentReportSelector,
    currentProjectIdSelector,
    timezoneOffsetSelector,
    // timeZoneHelperSelector,
  ],
  (
    createReportForm,
    modal,
    currentReport,
    currentProjectId,
    timezoneOffset,
    // timeZoneHelper,
  ) => ({
    fields: {
      type: createReportForm,
    },
    modal,
    currentReport,
    currentProjectId,
    initialValues: {
      name: formatDate(timezoneOffset, moment(), 'MMMM DD, YYYY, h:mm:ss A'),
      // name: timeZoneHelper.formatDate(moment(), 'MMMM DD, YYYY, h:mm:ss A'),
    },
  }),
);

@connect(CreateReportSelector)
@reduxForm({
  form: 'createDailyTaskCompleteReportModal',
})
export default class CreateDailyTaskCompleteReportModal extends Component {
  static propTypes = {
    fields: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    modal: PropTypes.instanceOf(Map),
    currentReport: PropTypes.object,
    currentProjectId: PropTypes.string,
    reset: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = {
      page: 1,
      initialized: false,
    };
  }


  toggleModal = e => {
    const { dispatch } = this.props;
    e.preventDefault();

    dispatch(
      ModalActions.toggleModal({
        name: 'createDailyTaskCompleteReportModal',
        options: {},
      }),
    );
  };

  async submit(values, dispatch) {
    const { reset, currentProjectId, modal } = this.props;
    const validation = {};
    const type = 'Daily Task Complete';
    const obj = {
      name: values.name,
      description: values.description,
      type,
    };

    // TODO: NEED TO COMPARE OBJ TO CURRENT REPORT BEFORE CREATING A NEW REPORT

    const res = await validateAndDispatch(
      dispatch,
      ReportActions.createReport(obj),
      validation,
      values,
    );

    const newReport = modal.getIn(['options', 'initializeValues']);
    reset();
    dispatch(
      ModalActions.hideModal({ name: 'createDailyTaskCompleteReportModal' }),
    );
    if (res) {
      dispatch(ReportActions.runReport(currentProjectId, res.result.result));
      if (newReport) {
        const projectId =
          res.result.entities.report[res.result.result].project_id;
        dispatch(push(`/project/${projectId}/reports`));
      }
    }
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <div className="fs-modal-content">
        <h4>Create New Daily Task Complete Report</h4>
        <div>
          <form>
            <div className="modal-form-wrapper">
              <fieldset className="form-group">
                <Field
                  name="name"
                  wrapperClassName="form-group row mb-2"
                  labelClassName="col-sm-3 col-form-label"
                  containerClassName="col-sm-9"
                  label="Name"
                  type="text"
                  component={InputBox}
                  placeholder="Name of report"
                  className="form-control"
                />
              </fieldset>
            </div>
            <div className="modal-form-button-wrapper">
              <button
                className="btn btn-primary modal-submit-btn"
                onClick={handleSubmit(this.submit)}
              >
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/CreateDailyTaskCompleteReportModal.js